import CardPost from "../../v2023/UI/Card/card-post"
import { NavCard } from "../../v2024/card"
import { Newsletter } from "../../v2024/newsletter"
import { redirectToThankYou } from "../../../utils/thank-you-access"
import React from "react"

export const ResourcesSection = ({ title, items, newsletter, newsletterForm, thankYou, lang }) => {
    return (
        <li className="menu-options__options__option">
            <span>{title}</span>
            <div className="option__menu">
                <div className="container container--newsletter">
                    <div className="option__menu__section">
                        {items.map((item, index) =>
                            <div className="section__column">
                                <span className="section__column__title">{item.section_title}</span>
                                {index < 1 ?
                                    <>
                                        {item.section_items.map((element, index) => {
                                            return <CardPost
                                                key={index}
                                                name={element.title}
                                                description={element.description}
                                                image={element.image}
                                                horizontal
                                                url={element.url}
                                                size="sm"
                                            />
                                        })}
                                    </>
                                    :
                                    <>
                                        {item.section_items.map(element =>
                                            <NavCard
                                                title={element.title}
                                                link={element.url}
                                                icon={element.image}
                                                description={element.description}
                                                size="lg"
                                            />
                                        )}
                                    </>
                                }
                            </div>
                        )}
                    </div>
                    <div className="option__menu__section option__menu__section--gray option__menu__section--gray--newsletter">
                        <Newsletter
                            lang={lang}
                            title={newsletter.title}
                            description={newsletter.description}
                            form={newsletterForm}
                            hideTextsOnSubmit={false}
                            redirectToThankYou={() => redirectToThankYou(lang, thankYou.url)}
                        />
                    </div>
                </div>
            </div>
        </li>
    )
}